var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee-headline max-w-wide"},[_c('h1',{ref:"headline",domProps:{"innerHTML":_vm._s(_vm.headline)}}),(_vm.subhead)?_c('h2',{ref:"subhead",domProps:{"innerHTML":_vm._s(_vm.subhead)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }